import { render, staticRenderFns } from "./EventDetails.vue?vue&type=template&id=2ea07624&scoped=true&"
import script from "./EventDetails.vue?vue&type=script&lang=ts&"
export * from "./EventDetails.vue?vue&type=script&lang=ts&"
import style0 from "./EventDetails.vue?vue&type=style&index=0&id=2ea07624&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea07624",
  null
  
)

export default component.exports